var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mo-gridss"},_vm._l((_vm.shuffleGames),function(game){return _c('game-item',{key:game.handle,staticStyle:{"height":"100%","width":"100%","box-shadow":"none","border-radius":"4px","display":"flex","border":"none","padding":"0px"},attrs:{"game":game,"showTitle":false}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }